import type { ReactNode } from "react"

type AuthPageShellProps = {
  children: ReactNode
  /** Default centers the form; pass false for scrollable flows like onboarding. */
  centered?: boolean
}

// Shared dark auth surface for login/signup — one continuous #0C0C0C field that
// fills the viewport so html/body never bleed a second black band at the bottom.
export function AuthPageShell({ children, centered = true }: AuthPageShellProps) {
  return (
    <div
      className={`relative min-h-dvh overflow-x-clip bg-[#0C0C0C] text-white ${
        centered ? "flex items-center justify-center p-4 py-12 sm:p-8" : ""
      }`}
    >
      {/* Near-invisible ambient depth — keeps the form from reading flat on the page. */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 top-1/3 h-96 w-96 rounded-full bg-white/[0.02] blur-[130px]" />
        <div className="absolute -right-40 bottom-1/4 h-96 w-96 rounded-full bg-emerald-500/[0.04] blur-[130px]" />
      </div>

      <div className="relative w-full max-w-md px-6 py-10 sm:px-9">{children}</div>
    </div>
  )
}

// BOOTH-system inputs: thin pills on off-black, hairline border, emerald focus.
export const authFieldClass =
  "auth-field h-10 w-full rounded-full border border-white/10 bg-white/[0.03] px-4 text-[13px] text-white placeholder:text-neutral-500 outline-none transition-all focus:border-emerald-500/50 focus:bg-white/[0.05] focus:ring-2 focus:ring-emerald-500/10"

// Premium dark pill shared with the dashboard Withdraw button.
export const authPillGradient = { background: "linear-gradient(to bottom, #1B1B1D, #0F0F10)" }
